import React from "react";
import { CheckCircle, XCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const doesSupport = [
  "Qualified clinical organization access",
  "Licensed provider-led care models",
  "503A/503B pharmacy pathway routing",
  "Lab and fulfillment coordination",
  "Compliance-aware intake and vendor routing",
  "Provider network support",
  "Patient-specific prescription pathways where applicable",
];

const doesNotSupport = [
  "Personal sourcing of any kind",
  "Research-use-only products for human use",
  "Dosing advice or dosing recommendations",
  "Diagnosis or treatment recommendations",
  "Unverified vendor routing",
  "Products for consumers without clinical affiliation",
];

export default function ComplianceAccess() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="pt-28 pb-16 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-blue-600 mb-4">Compliance</p>
          <h1 className="text-5xl font-medium text-slate-900 mb-5" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Built to reduce confusion,<br />not create risk
          </h1>
          <p className="text-xl text-slate-600">
            Apexum supports qualified clinical organizations and licensed provider-led care models through compliance-aware access to pharmacy, lab, and fulfillment infrastructure.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-8 mb-14">
            <div className="bg-emerald-50 rounded-3xl p-7 border border-emerald-100">
              <h3 className="text-lg font-semibold text-emerald-800 mb-5" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Apexum supports
              </h3>
              <div className="space-y-3">
                {doesSupport.map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <CheckCircle size={17} className="text-emerald-600 mt-0.5 flex-shrink-0" />
                    <p className="text-sm text-emerald-900">{item}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-red-50 rounded-3xl p-7 border border-red-100">
              <h3 className="text-lg font-semibold text-red-800 mb-5" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Apexum does not support
              </h3>
              <div className="space-y-3">
                {doesNotSupport.map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <XCircle size={17} className="text-red-500 mt-0.5 flex-shrink-0" />
                    <p className="text-sm text-red-900">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="bg-slate-900 rounded-3xl p-8 text-white">
            <h3 className="text-xl font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Compliance Statement</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Apexum Partners does not provide medical advice, prescribe medications, or support research-use-only products for human use. All clinical decisions must be made by appropriately licensed providers.
            </p>
            <p className="text-slate-300 leading-relaxed">
              Pharmacy, fulfillment, and vendor pathways are subject to qualification, partner review, applicable law, and current regulatory guidance. GLP-1 availability and fulfillment pathways are subject to current law, provider review, pharmacy partner policy, and applicable FDA/state guidance.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
